module.exports = __webpack_public_path__ + "static/illustration-features-tab-3-7f696303479b76b89e45fcf33b7aff4b.svg";